module.exports = __webpack_public_path__ + "static/scale-model-of-casemate-museum-of-fort-monroe-in-hampton-virginia-70aedc4cc8cbe1597a66c4302d06691b.png";